// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");

function t_encode(v) {
  switch (v.TAG | 0) {
    case /* Px */0 :
        return [
                "Px",
                Decco.intToJson(v._0)
              ];
    case /* VH */1 :
        return [
                "VH",
                Decco.floatToJson(v._0)
              ];
    case /* VW */2 :
        return [
                "VW",
                Decco.floatToJson(v._0)
              ];
    case /* Percent */3 :
        return [
                "Percent",
                Decco.floatToJson(v._0)
              ];
    case /* Em */4 :
        return [
                "Em",
                Decco.floatToJson(v._0)
              ];
    
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Em" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Em */4,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Percent" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Percent */3,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Px" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Px */0,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "VH" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* VH */1,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "VW" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* VW */2,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function toCSSValue(v) {
  switch (v.TAG | 0) {
    case /* Px */0 :
        return String(v._0) + "px";
    case /* VH */1 :
        return v._0.toString() + "vh";
    case /* VW */2 :
        return v._0.toString() + "vw";
    case /* Percent */3 :
        return v._0.toString() + "%";
    case /* Em */4 :
        return v._0.toString() + "em";
    
  }
}

var Length = {
  t_encode: t_encode,
  t_decode: t_decode,
  toCSSValue: toCSSValue
};

function t_encode$1(v) {
  switch (v) {
    case /* Left */0 :
        return ["Left"];
    case /* Right */1 :
        return ["Right"];
    case /* Default */2 :
        return ["Default"];
    
  }
}

function t_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Default" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Default */2
                  };
          }
      case "Left" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Left */0
                  };
          }
      case "Right" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Right */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(v) {
  switch (v) {
    case /* Left */0 :
        return "Left";
    case /* Right */1 :
        return "Right";
    case /* Default */2 :
        return "Default";
    
  }
}

var Position = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "width",
                Decco.optionToJson(t_encode, v.width)
              ],
              [
                "height",
                Decco.optionToJson(t_encode, v.height)
              ],
              [
                "position",
                Decco.optionToJson(t_encode$1, v.position)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var width = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "width"), null));
  if (width.TAG === /* Ok */0) {
    var height = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "height"), null));
    if (height.TAG === /* Ok */0) {
      var position = Decco.optionFromJson(t_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "position"), null));
      if (position.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  width: width._0,
                  height: height._0,
                  position: position._0
                }
              };
      }
      var e = position._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".position" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = height._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".height" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = width._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".width" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify$1(param) {
  return "{width: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.map(param.width, toCSSValue)) + (", height: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.map(param.height, toCSSValue)) + (", position: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.map(param.position, stringify)) + "}")))));
}

exports.Length = Length;
exports.Position = Position;
exports.t_encode = t_encode$2;
exports.t_decode = t_decode$2;
exports.stringify = stringify$1;
/* No side effect */
